module.exports = __webpack_public_path__ + "img/logo.4e20ba38.png";